import { TextField as SerendieTextField } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX, RefObject, createRef } from "react";
import "./Styles.scss";
import React from "react";
import { components } from "../../Components";

export class TextField extends BaseComponent<ITextFieldProps, ITextFieldState>
{
    private inputElement: HTMLInputElement | null = null;
    public static requiredLabel = '*';

    private ref(inputElement: HTMLInputElement | null): void
    {
        this.inputElement = inputElement;
        const { ref } = this.props;

        if (typeof ref == 'function')
        {
            ref(inputElement);
        }
        else if (ref)
        {
            ref.current = inputElement;
        }
    }

    public componentDidMount(): void
    {
        this.updateRequiredLabel();
    }

    public componentDidUpdate(): void
    {
        this.updateRequiredLabel();
    }

    private updateRequiredLabel(): void
    {
        const requiredContainer = this.inputElement?.parentElement?.parentElement?.querySelector('label')?.querySelector('span');
        if (!requiredContainer)
        {
            return;
        }
        requiredContainer.innerText = this.props.requiredLabel ?? TextField.requiredLabel;
    }

    public render(): JSX.Element
    {
        return <SerendieTextField
            {...this.props}
            autoComplete={this.props.autoComplete || 'one-time-code'}
            ref={e => this.ref(e)}
            className={`${this.props.className ?? ''} serendie-textfield`}
        />
    }
}

export interface ITextFieldProps extends React.ComponentProps<typeof SerendieTextField>
{
    requiredLabel?: string;
}

export interface ITextFieldState { }
